module.exports = __webpack_public_path__ + "img/UL.3cc1cd83.jpg";